module.exports = __webpack_public_path__ + "img/frame.e29fad45.png";